import { Box, Button, Card, Dialog } from "@mui/material"
import { DataGridPro } from "@mui/x-data-grid-pro"
import React, { useEffect, useState } from "react"
import { MATERIALS } from "../../../core/utils/constants"
import CmChargeBlock from "../../Charger/cm/cmChargeBlock"

const columns = [
    { field: "name", type: "", headerName: "Name", hide: false, width: 700 },
    { field: "data", headerName: "Data", hide: false, width: 700 }
]

export default function Materials({ materials }) {
    const [chargeItemsDialog, setChargeItemsDialog] = useState(false)
    const [selectedRows, setSelectedRows] = useState([])
    const disable = selectedRows.length === 0

    const [rows, setRows] = useState([])

    useEffect(() => {
        setRows(
            materials.map(material => {
                return {
                    id: material.Id,
                    name: MATERIALS.get(material.Id) ?? material.Id,
                    data: material.Count
                }
            })
        )
    }, [materials])

    const handleSelectRows = ({ ids }) => {
        const selectedIDs = new Set(ids)
        const selectedRowData = rows.filter((row) => selectedIDs.has(row.id.toString()))
        setSelectedRows(selectedRowData)
    }

    return (
        <Card>
            <Box sx={{ width: "100%", height: 600 }}>
                <DataGridPro
                    checkboxSelection
                    onRowSelectionModelChange={handleSelectRows}
                    columns={columns}
                    rows={rows ?? []}>
                </DataGridPro>
            </Box>
            <Dialog open={chargeItemsDialog} fullWidth={true}>
                <CmChargeBlock
                    massCharge={false}
                    initialSelectedItems={selectedRows}
                />
                <Button
                    disabled={disable}
                    variant="contained"
                    color="success"
                    onClick={() => setChargeItemsDialog(!chargeItemsDialog)}>
                    Cancel
                </Button>
            </Dialog>
        </Card>
    )
}
